import { animated, useSpring } from "@react-spring/three";
import { Center, Text3D } from "@react-three/drei";
import { COURT_DIMENSIONS } from "./courtConstants";

export const ProgressBar = ({ progress }) => {
	// Smooth spring animation for polished appearance
	// Since progress is now time-based and updates every frame,
	// we use a very gentle spring to smooth it out
	const { smoothProgress } = useSpring({
		smoothProgress: progress,
		config: { tension: 280, friction: 60, mass: 1 },
	});
	const progressBarWidth = COURT_DIMENSIONS.WIDTH * 0.78;
	const barHeight = 0.6;
	const outlineHeight = barHeight + 0.3;
	const outlineWidth = progressBarWidth + 0.3;
	const positionY = 0.1;
	const positionZ = COURT_DIMENSIONS.HEIGHT / 2 + 1;

	const xOffset = COURT_DIMENSIONS.WIDTH / 2 - progressBarWidth / 2 - 0.09;

	return (
		<group position={[0, positionY, positionZ]} rotation={[-Math.PI / 2, 0, 0]}>
			{/* Progress text using Text3D */}
			<Center position={[xOffset - progressBarWidth / 2 - 1.7, -0.1, 0]}>
				<Text3D
					font="/fonts/helvetiker_bold.typeface.json"
					size={0.4}
					height={0.01}
					curveSegments={12}
				>
					Progress
					<meshStandardMaterial color="white" />
				</Text3D>
			</Center>

			{/* Bar Outline */}
			<mesh position={[xOffset, 0, -0.01]}>
				<planeGeometry args={[outlineWidth, outlineHeight]} />
				<meshStandardMaterial color="#555555" />
			</mesh>
			{/* Bar Background */}
			<mesh position={[xOffset, 0, 0]}>
				<planeGeometry args={[progressBarWidth, barHeight]} />
				<meshStandardMaterial color="#222222" />
			</mesh>
			{/* Bar Fill */}
			{progress > 0 && (
				<animated.mesh
					position-x={smoothProgress.to(
						(p) => xOffset - progressBarWidth / 2 + (progressBarWidth * p) / 2,
					)}
					position-y={0}
					position-z={0.01}
					scale-x={smoothProgress}
				>
					<planeGeometry args={[progressBarWidth, barHeight]} />
					<meshStandardMaterial color="white" />
				</animated.mesh>
			)}
		</group>
	);
};
